module.exports = __webpack_public_path__ + "static/ship-974f0c56f8438bfeba461a8c07e84b08.png";